/*
* Functions to create and load Notification settings boxes for eSIMs
*
* See notification_settings.liquid and esim-notifications-2.liquid for reference
*/

/*
  * Builds the notification settings checkboxes for a single eSIM
  *
  * @param {HTMLElement} newDiv - The div element to populate
  * @param {object} esim_info - The ESimInformation object
  * @param {string} displayFormat - How to display the eSIM name ('type_and_name', 'name_only', 'type_only')
*/
function buildEsimNotificationCheckboxes(newDiv, esim_info, displayFormat) {
  let esim_name = esim_info.customerRef ? esim_info.customerRef : esim_info.iccid;

  // Default to 'type_and_name' if no display format provided (backward compatibility)
  displayFormat = displayFormat || 'type_and_name';

  newDiv.className = 'notification_setting_box';

  newDiv.querySelector('#esim_typename').innerHTML = stripDataInfoFromProductName(esim_info.productName) + ' eSIM';

  // Format the name based on display setting
  if (displayFormat === 'name_only') {
    // Show name without parentheses
    newDiv.querySelector('#esim_name').innerHTML = esim_name;
  } else if (displayFormat === 'type_only') {
    // Name will be hidden by CSS, but still set it in case CSS changes
    newDiv.querySelector('#esim_name').innerHTML = '(' + esim_name + ')';
  } else {
    // Default: 'type_and_name' - show with parentheses
    newDiv.querySelector('#esim_name').innerHTML = '(' + esim_name + ')';
  }

  newDiv.querySelector('#email_toggle').checked = esim_info.notifications.email;
  newDiv.querySelector('#sms_toggle').checked = esim_info.notifications.sms;
  newDiv.querySelector('#esim_iccid').value = esim_info.iccid;

  return newDiv;
}
